import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService, SwalService } from '@core/services';
import { AwsService, TranslateService } from '__services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComplianceService } from '~/app/core/services/compliance.service';

@Component({
  selector: 'app-document-additional',
  templateUrl: './document-additional.component.html',
  styleUrls: ['./document-additional.component.scss']
})
export class DocumentAdditionalComponent implements OnInit, OnDestroy {
  @Input() set detail(value) {
    if (value) {
      this.documentDetail = value;
    }
  };
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>()
  @Output() saveSuccess: EventEmitter<any> = new EventEmitter<any>()
  addFileForm: FormGroup;
  saving: boolean = false;
  private destroy$: Subject<any> = new Subject();
  documentDetail;

  constructor(
    private fb: FormBuilder,
    private commonService: CommonService,
    private complianceService: ComplianceService,
    private translationService: TranslateService,
    private awsService: AwsService
  ) { }

  ngOnInit(): void {
    this.initAddFileForm();
  }

  initAddFileForm() {
    this.addFileForm = this.fb.group({
      file: [null, Validators.required],
      reason: [null, Validators.required]
    })
  }

  onCancel() {
    this.cancel.emit();
  }

  onSave() {
    if(this.addFileForm.invalid) {
      return
    }
    this.saving = true
    const {file, reason} = this.addFileForm.value;
    this.awsService.uploadFileEncryption(
      'documents/documents',
      file,
    ).then((res: any) => {
      const obj = {
        uri: res.key,
        reason,
      }
      this.updateDocumentById(obj)
    }).catch(err => {
      this.saving = false;
      SwalService.warning(err?.message);
    });
  }

  updateDocumentById(obj): void {
    const data = {
      documents: [obj]
    }
    this.complianceService.updateDocumentValidateById(this.documentDetail.id, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
            this.saving = false;
          SwalService.success(
            this.translationService.translate('Updated the document successfull')
          ).then(() => {
            this.saveSuccess.emit(
              {
                s3_key: obj.uri,
                name: obj.uri.split('/').slice(-1)[0],
                added_reason: obj.reason
              }
            );
          });
        },
        (err) => {
          this.saving = false;
          SwalService.warning(err.message);
        }
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
